///<reference path="text-base.ts"/>

module Meevo.Components.Controls.SmartMover {

    export interface ITextTotalSelected extends ISmartMoverTextBase {
        getText($translate: ng.translate.ITranslateService, count: number): string;
    }

    export class TextTotalSelected extends SmartMoverTextBase implements ITextTotalSelected {

        getText($translate: ng.translate.ITranslateService, count: number): string {
            return $translate.instant(this.text, {number: count});
        }
    }
}
